/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { StrictHttpResponse } from '../strict-http-response';
import { WeatherApiConfiguration } from '../weather-api-configuration';

import { ChangeActive$Params, changeActive } from '../fn/region/change-active';
import { GetRegion$Params, getRegion } from '../fn/region/get-region';
import { GetRegions$Params, getRegions } from '../fn/region/get-regions';
import { SaveRegion$Params, saveRegion } from '../fn/region/save-region';
import { UpdateRegion$Params, updateRegion } from '../fn/region/update-region';
import { Region } from '../models/region';

/**
 * Region API
 */
@Injectable({ providedIn: 'root' })
export class RegionService extends BaseService {
   constructor(config: WeatherApiConfiguration, http: HttpClient) {
      super(config, http);
   }

   /** Path part for operation `getRegions()` */
   static readonly GetRegionsPath = '/api/weather/region';

   /**
    * This method provides access to the full `HttpResponse`, allowing access to response headers.
    * To access only the response body, use `getRegions()` instead.
    *
    * This method doesn't expect any request body.
    */
   getRegions$Response(params?: GetRegions$Params, context?: HttpContext): Observable<StrictHttpResponse<Region>> {
      return getRegions(this.http, this.rootUrl, params, context);
   }

   /**
    * This method provides access only to the response body.
    * To access the full response (for headers, for example), `getRegions$Response()` instead.
    *
    * This method doesn't expect any request body.
    */
   getRegions(params?: GetRegions$Params, context?: HttpContext): Observable<Region> {
      return this.getRegions$Response(params, context).pipe(map((r: StrictHttpResponse<Region>): Region => r.body));
   }

   /** Path part for operation `updateRegion()` */
   static readonly UpdateRegionPath = '/api/weather/region';

   /**
    * This method provides access to the full `HttpResponse`, allowing access to response headers.
    * To access only the response body, use `updateRegion()` instead.
    *
    * This method sends `application/json` and handles request body of type `application/json`.
    */
   updateRegion$Response(params: UpdateRegion$Params, context?: HttpContext): Observable<StrictHttpResponse<Region>> {
      return updateRegion(this.http, this.rootUrl, params, context);
   }

   /**
    * This method provides access only to the response body.
    * To access the full response (for headers, for example), `updateRegion$Response()` instead.
    *
    * This method sends `application/json` and handles request body of type `application/json`.
    */
   updateRegion(params: UpdateRegion$Params, context?: HttpContext): Observable<Region> {
      return this.updateRegion$Response(params, context).pipe(map((r: StrictHttpResponse<Region>): Region => r.body));
   }

   /** Path part for operation `saveRegion()` */
   static readonly SaveRegionPath = '/api/weather/region';

   /**
    * This method provides access to the full `HttpResponse`, allowing access to response headers.
    * To access only the response body, use `saveRegion()` instead.
    *
    * This method sends `application/json` and handles request body of type `application/json`.
    */
   saveRegion$Response(params: SaveRegion$Params, context?: HttpContext): Observable<StrictHttpResponse<Region>> {
      return saveRegion(this.http, this.rootUrl, params, context);
   }

   /**
    * This method provides access only to the response body.
    * To access the full response (for headers, for example), `saveRegion$Response()` instead.
    *
    * This method sends `application/json` and handles request body of type `application/json`.
    */
   saveRegion(params: SaveRegion$Params, context?: HttpContext): Observable<Region> {
      return this.saveRegion$Response(params, context).pipe(map((r: StrictHttpResponse<Region>): Region => r.body));
   }

   /** Path part for operation `getRegion()` */
   static readonly GetRegionPath = '/api/weather/region/{id}';

   /**
    * This method provides access to the full `HttpResponse`, allowing access to response headers.
    * To access only the response body, use `getRegion()` instead.
    *
    * This method doesn't expect any request body.
    */
   getRegion$Response(params: GetRegion$Params, context?: HttpContext): Observable<StrictHttpResponse<Region>> {
      return getRegion(this.http, this.rootUrl, params, context);
   }

   /**
    * This method provides access only to the response body.
    * To access the full response (for headers, for example), `getRegion$Response()` instead.
    *
    * This method doesn't expect any request body.
    */
   getRegion(params: GetRegion$Params, context?: HttpContext): Observable<Region> {
      return this.getRegion$Response(params, context).pipe(map((r: StrictHttpResponse<Region>): Region => r.body));
   }

   /** Path part for operation `changeActive()` */
   static readonly ChangeActivePath = '/api/weather/region/changeActive';

   /**
    * This method provides access to the full `HttpResponse`, allowing access to response headers.
    * To access only the response body, use `changeActive()` instead.
    *
    * This method sends `application/json` and handles request body of type `application/json`.
    */
   changeActive$Response(params: ChangeActive$Params, context?: HttpContext): Observable<StrictHttpResponse<Region>> {
      return changeActive(this.http, this.rootUrl, params, context);
   }

   /**
    * This method provides access only to the response body.
    * To access the full response (for headers, for example), `changeActive$Response()` instead.
    *
    * This method sends `application/json` and handles request body of type `application/json`.
    */
   changeActive(params: ChangeActive$Params, context?: HttpContext): Observable<Region> {
      return this.changeActive$Response(params, context).pipe(map((r: StrictHttpResponse<Region>): Region => r.body));
   }
}
